module.exports = __webpack_public_path__ + "mx.33c30b31fa0b2d621d4b.svg";


//////////////////
// WEBPACK FOOTER
// D:/projects/feelway-pawnshop/pawnshop-web-client-feelway/src/assets/scss/icons/flag-icon-css/flags/mx.svg
// module id = ../../../../../src/assets/scss/icons/flag-icon-css/flags/mx.svg
// module chunks = styles